module.exports = __webpack_public_path__ + "static/media/SM.494ff576.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/SM.svg
// module id = 2262
// module chunks = 7